<template>
	<v-container fluid class="pl-0 pr-0">
		<v-card outlined flat min-height="138px">
			<v-row align="center" justify="start" no-gutters>
				<v-col>
					<v-card-text>
						<slot></slot>
					</v-card-text>
				</v-col>
			</v-row>
			<v-row align="center" justify="start" no-gutters class="pb-1">
				<v-col class="pb-2">
					<v-btn :color="state == 'yes' ? 'primary' : ''" @click="OnYes">Yes</v-btn>
				</v-col>
				<v-col class="pb-1">
					<v-btn :color="state == 'no' ? 'primary' : ''" @click="OnNo">No</v-btn>
				</v-col>
			</v-row>
			<v-row v-if="errors" align="center" justify="start" no-gutters>
				<v-col>
					<v-card-text class="error--text">
						{{ errors }}
					</v-card-text>
				</v-col>
			</v-row>
		</v-card>
	</v-container>
</template>

<script>
export default {
	name: 'DistinctYesNo',
	props: ['errors', 'initial'],
	data: () => ({
		state: 'none',
	}),
	watch: {
		initial() {
			this.state = this.initial;
			if (this.state == 'yes') {
				this.OnYes();
			} else if (this.state == 'no') {
				this.OnNo();
			}
		},
	},
	mounted() {
		if (this.initial) {
			this.state = this.initial;
		}
		if (this.state == 'yes') {
			this.OnYes();
		} else if (this.state == 'no') {
			this.OnNo();
		}
	},
	methods: {
		OnYes() {
			this.$emit('input', 'yes');
			this.state = 'yes';
		},
		OnNo() {
			this.$emit('input', 'no');
			this.state = 'no';
		},
	},
};
</script>
